import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { take } from 'rxjs/operators';

import { MessageService } from 'primeng/components/common/messageservice';

import { Contrato } from '../../../../base/vo/contrato';
import { Field } from '../../../../base/vo/formulario';
import { FilesWithRules } from '../../../../base/vo/uploadFile';
import { AdminContratosService } from '../../admin-contratos.service';
import { ModalVinculoComponent } from './modal-vinculo/modal-vinculo.component';


@Component({
  selector: 'app-form-vinculo',
  templateUrl: './form-vinculo.component.html',
  styleUrls: ['./form-vinculo.component.scss']
})
export class FormVinculoComponent implements OnInit {

  @Input() loading: boolean;
  @Input() contrato: Contrato;

  @Output() vinculoEmitter: EventEmitter<Contrato> = new EventEmitter();

  @ViewChild('modalVinculo')
  public modalVinculo: ModalVinculoComponent;

  public formGroup: FormGroup;
  public fields: Field[] = [
    {
      controlName: 'titulo',
      label: 'Titulo Documento',
    },
    {
      controlName: 'observacao',
      label: 'Observação',
    },
    {
      controlName: 'anexar',
      label: 'Anexar .xlsx',
    },
  ];

  public accept = '.xlsx';
  public filesWithRules: FilesWithRules;

  constructor(
    private readonly adminContratosService: AdminContratosService,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    private readonly messageService: MessageService,
  ) { }

  ngOnInit() {
    this.filesWithRules = {
      regras: null,
      filesUpload: {
        files: [],
      },
      validateRequiredFile: true,
      isInputDirty: false
    };

    this.formGroup = this.formBuilder.group({
      titulo: [this.contrato.titulo, [Validators.required]],
      observacao: [this.contrato.observacao, [Validators.required]],
    });
    this.formGroup.controls.titulo.disable();
    this.formGroup.controls.observacao.disable();


    if(!this.contrato.acoes.vincular) {
      this.router.navigate([`admin/contratos/`]);
    }
  }

  public onSubmit() {
    if (this.filesWithRules.filesUpload.files.length === 0) {
      this.filesWithRules.isInputDirty = true;
    } else {
      this.modalVinculo.openDialog();
    }
  }

  public vincularNao() {
    this.modalVinculo.closeDialog();
  }

  public vincularSim() {
    this.loading = true;
    const fileToUpload = this.adminContratosService.csvToFormData(this.filesWithRules.filesUpload.files[0])
    this.adminContratosService.uploadCSV(this.contrato.id, fileToUpload)
      .pipe(
        take(1)
      )
      .subscribe(
        response => {
        this.loading = true;
        this.contrato.urlAnexoVinculo = response.urlAnexoVinculo;
        if (this.contrato.urlAnexoVinculo !== null) {
          this.vinculoEmitter.emit(this.contrato);
        }
        },
        errorResponse => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: errorResponse.error.mensagem });
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/contratos/admin-contratos-novo/form-vinculo/form-vinculo.component.ts